<template>
  <div v-if="showContentDeliverer" class="container justify-content-center">
    <h1 class="text-center">ЗАПРОС НА ВЫПЛАТУ</h1>
    <div class="input-group mb-3">
      <input
        v-model="payoffSum"
        :title="`Не более ${userBalance}`"
        type="number"
        class="form-control"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        placeholder="Введите сумму выплаты"
        aria-label="Сумма выплаты"
        aria-describedby="payoff-btn"
      />
      <span class="input-group-text">Баланс: {{userBalance}}р</span>
    </div>
    <div class="input-group mb-3">
      <span class="input-group-text">Выберите карту</span>
      <select v-model='card' class="form-select form-select-md" aria-label=".form-select-md example">
        <option v-for='card in userCards' :key='card._id' :value='card._id'>{{ card.type }} {{ card.mask }}</option>
      </select>
      <a :href='yoomoneyCardAuthUrl()'>
      <button class="btn btn-outline-info">Добавить</button>
    </a>
    </div>
      <button
        :disabled="(payoffSum > userBalance) || !payoffSum || !card ? true : false"
        class="btn btn-primary"
        type="button"
        id="payoff-btn"
        @click="payoff()">
        Выплатить
      </button>
   
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue"
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import useCardsMixin from '@/components/cardsMixin.js'
import useCommonMixin from '@/components/commonMixin.js'

export default {
  name: "PayoffOrder",

  components: {},
  props: {
    payoffSumInit: {default: ''},
  },

  setup(props) {
    const store = useStore()
    const router = useRouter()
    const payoffSum = ref(props.payoffSumInit)
    const card = ref('')
    useCardsMixin()
    useCommonMixin()
    const { userBalance, getUserBalance, showContentDeliverer } = useCommonMixin()
    const { userCards, yoomoneyCardAuthUrl } = useCardsMixin()
    
    const payoff = () => {
      store.dispatch('payoffOrder', {cardId: card.value, amount: payoffSum.value})
      router.push({name: 'payofforders'})
    }
    
    onMounted(getUserBalance)

    return {
      userBalance,
      payoffSum,
      card,
      userCards,
      yoomoneyCardAuthUrl,  
      payoff,
      showContentDeliverer,
    };
  },
};
</script>

<style>
</style>

